import CryptoJS from 'crypto-js';
import { aesSecretKey, aesIvKey } from '../../Constants/index';

const AES_KEY = CryptoJS.enc.Utf8.parse(aesSecretKey);
const AES_IV = CryptoJS.enc.Utf8.parse(aesIvKey);

export function encryptValue(plainText, value) {
    if (value?.toLowerCase() === "false") return plainText;
    const encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(plainText),
        AES_KEY,
        {
            iv: AES_IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    return encrypted.toString(); // Base64 string
}

export function decryptValue(cipherText, value) {
    if (value?.toLowerCase() === "false") return cipherText;
    if (!cipherText) return cipherText;

    const decrypted = CryptoJS.AES.decrypt(cipherText, AES_KEY, {
        iv: AES_IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
}
